import { useTheme } from "@mui/material/styles";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Stepper from "@mui/material/Stepper";

import { WelcomeStep, WelcomeStepNumber } from "core/models/welcome";
import { useWelcome } from "../fabric";


export default function Steps() {
	const theme = useTheme();
	const { step, setStep } = useWelcome();
	const stepNumber = WelcomeStepNumber[step || WelcomeStep.One];

	const style = {
		root: {
			width: "100%",
			my: theme.spacing(2),
			".MuiSvgIcon-root:is(.Mui-completed)": {
				color: theme.palette.success.main
			},
			".MuiSvgIcon-root:is(.Mui-active)": {
				color: theme.palette.secondary.main
			}
		}
	};

	return (
		<Stepper nonLinear activeStep={stepNumber} alternativeLabel sx={style.root}>
			<Step completed={stepNumber > 0} >
				<StepButton onClick={() => setStep(WelcomeStep.One)}>Branding</StepButton>
			</Step>
			<Step completed={stepNumber > 1} >
				<StepButton onClick={() => setStep(WelcomeStep.Two)}>CMS</StepButton>
			</Step>
			<Step completed={stepNumber > 2} >
				<StepButton onClick={() => setStep(WelcomeStep.Three)}>Pricing</StepButton>
			</Step>
			<Step completed={stepNumber > 3}>
				<StepButton onClick={() => setStep(WelcomeStep.Four)}>Integrate</StepButton>
			</Step>
		</Stepper>
	);
};